import Shop from "../_data/models/Shop";
import {
    clearShopProfile, didAddShopBooth,
    didReceiveShopBooths, requestFailed, requestShopBooths, requestStarted,
    requestSucceeded
} from "../shop/actions";
import BoothRepository from "../_repositories/boothRepository";
import {addDataAction, updateDataAction} from "../_data/actions";
import {Map} from "immutable";
import * as _ from "lodash";
import {ResourceType} from "../_helpers/data";
import {plainToClass} from "class-transformer";
import Meta from "../_data/models/Meta";
import Booth from "../_data/models/Booth";


export const fetchBoothsByShop = (shopId: number, cursor: number = null, page: number = null) => {

    return (dispatch) => {
        dispatch(requestShopBooths());
        BoothRepository.listByShop(shopId, cursor, page, 25)
            .then(data => {
                const {booths, meta} = data;
                if (data.error) {
                    dispatch(requestFailed({requestErrors: ["Failed to retrieve shop booths."]}))
                }

                dispatch(addDataAction({
                    resource: ResourceType.booth,
                    data: booths
                }));


                let boothIds = _.map(booths, (each) => {
                    return [each["id"], parseInt(each["id"])];
                });


                return dispatch(didReceiveShopBooths({
                    ids: Map<number,number>(boothIds),
                    meta: plainToClass(Meta, meta)
                }));

            });
    }
};

export const saveBooth = (booth: Booth, cb: (booth?, errors?: string[]) => void) => {
    return (dispatch) => {

        return BoothRepository.saveBooth(booth)
            .then((data) => {

                let errors: string[] = [];

                const {booth} = data;

                dispatch(addDataAction({
                    resource: ResourceType.booth,
                    data: booth
                }));

                let boothId = [[booth.id, parseInt(booth["id"])]];
                dispatch(didAddShopBooth({
                    ids: Map<number,number>(boothId)
                }));

                cb(plainToClass(Booth, booth), errors);
            });


    }
};


// WEBPACK FOOTER //
// ./app/client/booth/middlewares.ts